type TickIconProps = {
  fill?: string
  id?: string
  width?: number
  height?: number
  className?: string
}

export const TickIcon: React.FC<TickIconProps> = ({ fill, width, height, id, className }) => {
  return (
    <div className={'TICKICON ' + className} id={id}>
      <svg
        width={width || '24'}
        height={height || width || '25'}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_12001_711)">
          <path
            d="M2.03125 12.5464C2.03125 15.1903 3.08153 17.7259 4.95103 19.5954C6.82054 21.4649 9.35613 22.5151 12 22.5151C14.6439 22.5151 17.1795 21.4649 19.049 19.5954C20.9185 17.7259 21.9688 15.1903 21.9688 12.5464C21.9688 9.90251 20.9185 7.36692 19.049 5.49742C17.1795 3.62792 14.6439 2.57764 12 2.57764C9.35613 2.57764 6.82054 3.62792 4.95103 5.49742C3.08153 7.36692 2.03125 9.90251 2.03125 12.5464Z"
            stroke={fill || '#F24923'}
            strokeWidth="1.5"
          />
          <path
            d="M7.69531 12.5464L10.8672 15.7183L16.3047 8.92139"
            stroke={fill || '#F24923'}
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_12001_711">
            <rect width="24" height="24" fill="white" transform="translate(0 0.546387)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
